export default class NumberValidator {
	isGreaterThan(value, maxValue) {
		return value > maxValue;
	}

	hasCharacters(value) {
		return /\D/g.test(value);
	}

	isEmpty(value) {
		//value is string
		return value === '';
	}

	isZero(value) {
		//value is integer
		return value === 0;
	}
}



// WEBPACK FOOTER //
// ./src/utils/numberValidator.js